import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalNotificationRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 24C4.75 13.369 13.369 4.75 24 4.75q.663 0 1.315.044a2 2 0 1 0 .268-3.99A24 24 0 0 0 24 .75C11.16.75.75 11.16.75 24c0 3.865.945 7.514 2.617 10.725c-.843 2.319-1.623 4.934-2.151 7.56c-.546 2.714 1.878 5.017 4.544 4.393c2.489-.583 5-1.368 7.259-2.18A23.16 23.16 0 0 0 24 47.25c12.84 0 23.25-10.41 23.25-23.25q0-.798-.053-1.583a2 2 0 1 0-3.991.268q.044.652.044 1.315c0 10.631-8.618 19.25-19.25 19.25a19.15 19.15 0 0 1-9.784-2.668a2 2 0 0 0-1.717-.153c-2.253.84-4.791 1.662-7.284 2.267c.545-2.58 1.354-5.168 2.213-7.414a2 2 0 0 0-.134-1.71A19.15 19.15 0 0 1 4.75 24M27.5 11a9.5 9.5 0 1 1 19 0a9.5 9.5 0 0 1-19 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalNotificationRemix
